/**
 * Initialize Mobile Swiper Engine for Social Proof Component Blocks
 */
function initSocialProofSwiper() {
  const swiperContainer = document.querySelector('.social-proof__slider-wrapper');
  if (!swiperContainer) return;

  let swiperInstance = null;

  function handleSwiperLifecycle() {
    const isMobile = window.innerWidth < 750;

    if (isMobile) {
      if (!swiperInstance) {
        // Initialize Swiper context instance on mobile layout rules matching image_b14015.png
        swiperInstance = new Swiper('.social-proof__slider-wrapper', {
          slidesPerView: 1.1,
          centeredSlides: false,
          spaceBetween: 16,
          grabCursor: true,
          pagination: {
            el: '.social-proof__pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiperInstance) {
        // Safely wipe out and destroy instances on desktop resolution transformations
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  // Initial Check Trigger
  handleSwiperLifecycle();

  // Watch for orientation resize view bounds adjustments
  window.addEventListener('resize', handleSwiperLifecycle);
}

// Ensure execution handles theme asynchronous DOM rendering loops safely
document.addEventListener('DOMContentLoaded', initSocialProofSwiper);
document.addEventListener('shopify:section:load', initSocialProofSwiper);


(function() {
  function initMoriVideo(sectionContainer) {
    const playButton = sectionContainer.querySelector('[data-play-button]');
    const coverOverlay = sectionContainer.querySelector('[data-cover-overlay]');
    const nativeVideo = sectionContainer.querySelector('.mori-native-video');
    const iframe = sectionContainer.querySelector('iframe');

    if (!playButton || !coverOverlay) return;

    playButton.addEventListener('click', function(e) {
      e.preventDefault();
      coverOverlay.classList.add('hidden');
      
      if (nativeVideo) {
        // Unmute if browser blocked it, then play
        nativeVideo.muted = false; 
        const playPromise = nativeVideo.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log("Playback prevented by browser. Retrying muted...");
            nativeVideo.muted = true;
            nativeVideo.play();
          });
        }
      } else if (iframe) {
        let symbol = iframe.src.indexOf('?') > -1 ? '&' : '?';
        // Force autoplay parameter onto the YouTube/Vimeo source link
        iframe.src += symbol + "autoplay=1&mute=0";
      }
    });
  }

  // Initialize on standard page load
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.mori-video-inner').forEach(initMoriVideo);
  });

  // Theme Editor Fix: Re-initialize when customized/reloaded in the admin panel
  document.addEventListener('shopify:section:load', function(e) {
    const sectionVideo = e.target.querySelector('.mori-video-inner');
    if (sectionVideo) initMoriVideo(sectionVideo);
  });
})();




/**
 * Initialize individual Video Review Swiper configurations across themes
 * @param {string} sectionId - The Shopify dynamic generated section token ID
 */
window.initVideoReviewSwiper = function(sectionId) {
  const swiperEl = document.querySelector(`.video-review-swiper-${sectionId}`);
  
  if (swiperEl && typeof Swiper !== 'undefined') {
    new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      grabCursor: true,
      navigation: {
        nextEl: `.swiper-nav-next-${sectionId}`,
        prevEl: `.swiper-nav-prev-${sectionId}`,
      },
      breakpoints: {
        480: { slidesPerView: 1.8, spaceBetween: 16 },
        768: { slidesPerView: 3.2, spaceBetween: 16 },
        1024: { slidesPerView: 4, spaceBetween: 20 }
      }
    });
  }
};

/**
 * Handle individual card video engine playback triggers
 * Global click binding mapped via section's inline onclick attribute handler
 */
window.toggleReviewVideo = function(overlay) {
  const container = overlay.closest('.video-review-card__inner');
  const mediaItem = container.querySelector('.video-review-card__video');

  // Pause all other videos currently running across the section
  document.querySelectorAll('.video-review-card__inner').forEach(card => {
    if (card !== container) {
      card.classList.remove('is-playing');
      const nativeVid = card.querySelector('video');
      if (nativeVid) nativeVid.pause();
      
      const iframe = card.querySelector('iframe');
      if (iframe) {
        if (iframe.src.includes('youtube')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (iframe.src.includes('vimeo')) {
          iframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }
    }
  });

  // Control video playback state toggles on the clicked item
  if (mediaItem) {
    if (!container.classList.contains('is-playing')) {
      container.classList.add('is-playing');
      if (mediaItem.tagName === 'VIDEO') {
        mediaItem.play();
      } else if (mediaItem.tagName === 'IFRAME') {
        if (mediaItem.src.includes('youtube')) {
          mediaItem.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (mediaItem.src.includes('vimeo')) {
          mediaItem.contentWindow.postMessage('{"method":"play"}', '*');
        }
      }
    } else {
      container.classList.remove('is-playing');
      if (mediaItem.tagName === 'VIDEO') {
        mediaItem.pause();
      } else if (mediaItem.tagName === 'IFRAME') {
        if (mediaItem.src.includes('youtube')) {
          mediaItem.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (mediaItem.src.includes('vimeo')) {
          mediaItem.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      }
    }
  }
};